import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as OrganizationId } from '../../organization';

export const Organization = struct({
	equalsType: EqualsType,
	values: array(OrganizationId),
});
